"use client";
import dynamic from "next/dynamic";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { CrossSellViewMode } from "@/api/AppApi/services/company/interfaces/ICompany";
import CartCrossSellSection from "./CartCrossSellSection";

// A modal is never part of the cart's first paint.
const CartOpenCrossSellPopup = dynamic(() => import("./CartOpenCrossSellPopup"), {
  ssr: false,
});

/**
 * Cross-sell on the cart page, in whichever form the merchant configured.
 *
 * Mounted only for a non-empty cart (see `Cart.tsx`). Popup mode ALSO fires on
 * add-to-cart from anywhere in the store — that trigger lives in
 * `CartCrossSellPopupHost`, mounted in the layout.
 */
const CartCrossSell: React.FC = () => {
  const { data: companyData } = useGetCompanyQuery();
  const cartSettings = companyData?.result?.theme?.components?.cart;

  if (!cartSettings?.show_crosssell_products) return null;

  return cartSettings.crosssell_view_mode === CrossSellViewMode.popup ? (
    <CartOpenCrossSellPopup />
  ) : (
    <CartCrossSellSection />
  );
};

export default CartCrossSell;
